// extracted by mini-css-extract-plugin
export default {"container":"_5svxSfO-46"};
    if(module.hot) {
      // 1648553820999
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  